import { queryOptions, useQuery } from '@tanstack/react-query';

import { getMyPermissions } from '../api';

// Shared options so the hook and loader-side `ensureQueryData` use the same
// cache entry — permissions are fetched once per session.
export const myPermissionsQueryOptions = () =>
  queryOptions({
    queryKey: ['my-permissions'],
    queryFn: getMyPermissions,
    staleTime: Infinity,
  });

export const useMyPermissions = () => useQuery(myPermissionsQueryOptions());
